import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const Done = () => {
  return (
    <>
      <Text.Header2>
        {i18n.t('payroll_integrations.incidences.datev_api.leave.done.title')}
      </Text.Header2>
      <Box>{i18n.t('payroll_integrations.incidences.datev_api.leave.done.message')}</Box>
    </>
  )
}

export default Done
